// eventTracking
window.eventTrackData = window.eventTrackData || [];
function eventTrack() {
  eventTrackData.push(arguments);
}

//api地址
let logHost = "https://puainta.com";
let eventTracking = null;

document.addEventListener("DOMContentLoaded", function () {
  eventTracking = new EventTrackingSystem();
});

window.addEventListener("load", function () {
  setBidAndSidToUrl();
});

//用户退出或者刷新调用事件
/*window.addEventListener("unload", function () {
    onUnload()
});*/

window.addEventListener("pagehide", function (event) {
  if (event.persisted) {
    // 页面被存入BFCache
  } else {
    onUnload();
    // 页面完全卸载
    // 可以在这里执行清理操作
  }
});
window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    // 页面从BFCache恢复
    // 可以在这里恢复状态
  }
});

document.addEventListener("visibilitychange", function () {
  if (document.hidden) {
    onUnload();
  } else {
  }
});

// 埋点系统
function EventTrackingSystem(data) {
  this.init(data).then((res) => {
    this.render();
  });
}

EventTrackingSystem.prototype = {
  data: {},
  constructor: EventTrackingSystem,
  init: async function (data) {
    let _this = this;
    let time = new Date();
    let paramBid = getQueryParam("bid");
    let paramSid = getQueryParam("sid");
    let paramIdx = getQueryParam("idx");
    let paramRecordUrls = getQueryParam("recordUrls");
    if (paramRecordUrls) {
      setSessionCookie("recordUrls", paramRecordUrls);
    }

    let sid = ""; //浏览id
    let bid = ""; // 浏览器id
    let idx = "1";
    let recordUrls = "";
    let isInit = true;

    // 如果url中没有，则先从缓存中获取，缓存没有，再判断eventTrackData有没有，没有再生成
    sid = getCookie("customSessionId");
    if (!sid || sid === "null") {
      // 缓存没有，
      let initData = getInitData();
      console.log("initData", initData);
      if (!initData) {
        // eventTrackData也没有，生成新的sid跟bid
        sid = uuid();
        if (window.location.hostname !== "puainta.com") {
          let prefix = window.location.hostname.split(".")[0];
          sid = prefix + "." + sid;
        }
        idx = 1;
        recordUrls = window.location.pathname;
        isInit = false;
      } else {
        sid = initData[1].sid;
      }
    }
    bid = localStorage.getItem("customId");
    if (!bid || bid === "null") {
      let initData = getInitData();
      if (!initData) {
        bid = "b_" + sid;
        if (window.location.hostname !== "puainta.com") {
          let prefix = window.location.hostname.split(".")[0];
          bid = prefix + "." + bid;
        }
        isInit = false;
      } else {
        bid = initData[1].bid;
      }
    }

    if (paramBid && paramSid) {
      // 如果url中带有bid跟sid，就用url中的参数
      bid = paramBid;
      sid = paramSid;
      idx = paramIdx;
      recordUrls = paramRecordUrls;
      isInit = false;
    }

    if (!isInit) {
      eventTrack("init", {
        bid: bid,
        sid: sid,
        idx: idx,
        recordUrls: recordUrls,
      });
    }
    setSessionCookie("customSessionId", sid);
    localStorage.setItem("customId", bid);
    if (window.clarity) {
      window.clarity("identify", bid, sid, window.location.pathname, "");
    }

    // 获取访问次数，如果不存在则初始化为 1
    let visitCount = getCookie("visitCount");
    if (visitCount) {
      visitCount = parseInt(visitCount) + 1;
    } else {
      visitCount = 1;
    }
    setSessionCookie("visitCount", visitCount);

    // 访问路径
    recordCurrentUrl();
    let urls = getRecordUrls();
    this.data = {
      viewStartTime: new Date().getTime(),
      customSessionId: sid,
      customId: bid,
      bid: bid,
      sid: sid,
      url: window.location.href,
      urlIndex: visitCount,
      referrer: document.referrer,
      scrollHeight: 0,
      platform: navigator.platform,
      isClickBuyNow: 0,
      id: "",
      recordUrls: urls,
    };
    //事件初始化
    this.event();
    //方法初始化
    this.method();
  },
  //最后初始化
  render: function (data, callback) {
    let _this = this;
    _this.eventTrackingStart();
    if (typeof callback === "function") {
      callback.call(_this);
    }
  },
  //事件方法（监听或者click）
  event: function () {
    // 获取页面所有a标签
    let allLinks = document.getElementsByTagName("a");

    let sid = getCookie("customSessionId");
    let bid = localStorage.getItem("customId");
    let idx = getCookie("visitCount");
    let recordUrls = getRecordUrls();

    // 要添加的参数
    let params = {
      sid: sid,
      bid: bid,
      idx: idx,
      recordUrls: recordUrls,
    };
    // 遍历所有a标签
    for (let link of allLinks) {
      // 检查是否有href属性
      if (link.href) {
        try {
          const url = new URL(link.href);
          // 检查是否是从puainta.com跳到shop.puainta.com
          if (url.hostname !== "puainta.com") {
            // 添加参数
            url.searchParams.append("sid", params.sid);
            url.searchParams.append("bid", params.bid);
            url.searchParams.append("idx", params.idx);
            url.searchParams.append("recordUrls", params.recordUrls);
            // 更新链接的href
            link.href = url.toString();
          }
        } catch (e) {
          // 处理无效URL的情况
          console.warn("Invalid URL:", link.href);
        }
      }
    }
  },
  //重新加载
  heavyLoad: function (data) {},
  //公用方法
  method: function () {
    let _this = this;

    //首次初始化后第一个调用的方法.
    function eventTrackingStart() {
      //如果有产品页面才需要赋值
      if (window.location.pathname.includes("/products/")) {
        let btnBuy1 = document.querySelector(
          ".goods-info .info-footer .buy-button"
        );
        if (btnBuy1) {
          btnBuy1.addEventListener("click", function () {
            _this.data.isClickBuyNow = 1;
          });
        }
        let btnBuy2 = document.querySelector(".shopline-element-add-to-cart");
        if (btnBuy2) {
          btnBuy2.addEventListener("click", function () {
            _this.data.isClickBuyNow = 1;
          });
        }
        let btnBuy3 = document.querySelector(".pay-button-buy-now");
        if (btnBuy3) {
          btnBuy3.addEventListener("click", function () {
            _this.data.isClickBuyNow = 1;
          });
        }
        // 为shopline按钮添加埋点
        window.addEventListener("message", function (event) {
          // console.log(event.data);
          if ((event.data.type = "buy-click")) {
            _this.data.isClickBuyNow = 1;
          }
        });
        // console.log('submit')
        let btnBuy4 = document.querySelector(".product-form__submit");
        if (btnBuy4) {
          btnBuy4.addEventListener("click", function () {
            _this.data.isClickBuyNow = 1;
          });
        }
        /*$(".goods-info .info-footer .buy-button").click(function () {
                    _this.data.isClickBuyNow = 1
                })*/
      }

      // 获取页面总高度
      let documentHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight
      );
      let footerBox = document.querySelector(".footer-box");
      let footerHeight = footerBox ? footerBox.offsetHeight : 0;
      let bodyHeight = documentHeight - footerHeight;
      window.addEventListener("scroll", function () {
        setHeight(bodyHeight);
      });
      /*$(window).on('scroll', function () {
                setHeight(bodyHeight)
            });*/
      setHeight(bodyHeight);

      let sid = getCookie("customSessionId");
      let bid = localStorage.getItem("customId");
      let idx = getCookie("visitCount");
      let recordUrls = getRecordUrls();

      let setData = {
        url: _this.data.url,
        url_index: _this.data.urlIndex,
        referrer: _this.data.referrer,
        enter_time: _this.data.viewStartTime,
        leave_time: new Date().getTime(),
        scroll_height: _this.data.scrollHeight,
        platform: _this.data.platform,
        is_click_buy_now: _this.data.isClickBuyNow,
        bid: bid,
        sid: sid,
        idx: idx,
        recordUrls: recordUrls,
      };
      if (bid) {
        //进来发送
        ajaxRequest({
          url: "/api/Log/log",
          data: setData,
          back: true,
        }).then((response) => {
          _this.data.id = response?.data?.id || "";
        });
      }
    }

    function setHeight(h) {
      let maxScrollHeight = 0;
      // 获取当前滚动高度
      let currentScroll =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      // 更新最大滑动高度
      if (currentScroll > maxScrollHeight) {
        maxScrollHeight = currentScroll;
        // 计算最大滑动高度的百分比
        const scrollPercentage = (maxScrollHeight / h) * 100;
        if (
          Number(_this.data.scrollHeight) < Number(scrollPercentage.toFixed(2))
        ) {
          _this.data.scrollHeight = scrollPercentage.toFixed(2);
        }
      }
    }

    this.eventTrackingStart = eventTrackingStart.bind(this);
    this.setHeight = setHeight.bind(this);
  },
};

function getInitData() {
  console.log("window.eventTrackData", window.eventTrackData.length);

  return window.eventTrackData.find((item) => {
    console.log("item", item[0]);
    return item[0] === "init";
  });
}

function recordCurrentUrl() {
  let url = window.location.pathname;
  if (window.location.hostname !== "puainta.com") {
    let prefix = url.split(".")[0];
    url = prefix + "." + url;
  }
  let urls = getCookie("recordUrls");
  if (!urls) {
    urls = url;
  } else {
    urls = urls + "," + url;
  }
  let arr = urls.split('');
  arr = uniqueArray(arr);
  let last10Urls = arr.splice(-10)
  setSessionCookie("recordUrls", last10Urls.join(','));
}

function getRecordUrls() {
  let urls = getCookie("recordUrls");
  if (!urls) {
    return "";
  }
  urls = urls.split(",");
  urls = uniqueArray(urls);
  return urls.join(",");
}

function uniqueArray(arr) {
  const result = [];
  const seen = new Set();
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    if (!isEmpty(item) && !seen.has(item)) {
      result.push(item);
      seen.add(item);
    }
  }
  return result;
}

function isEmpty(value) {
  if (value === null || value === undefined || value === "null") {
    return true;
  }
  if (typeof value === "string" && value.trim() === "") {
    return true;
  }
  if (Array.isArray(value) && value.length === 0) {
    return true;
  }
  if (typeof value === "object" && Object.keys(value).length === 0) {
    return true;
  }
  return false;
}

function checkIsProductUrl(path) {
  const regex = /^\/products\/([a-z-]+)$/;
  const match = path.match(regex);
  if (match) {
    return true;
  } else {
    return false;
  }
}

function onUnload() {
  if (eventTracking && eventTracking.data) {
    let sid = getCookie("customSessionId");
    let bid = localStorage.getItem("customId");
    let idx = getCookie("visitCount");
    let recordUrls = getRecordUrls();

    let setData = {
      url: eventTracking.data.url,
      url_index: eventTracking.data.urlIndex,
      referrer: eventTracking.data.referrer,
      enter_time: eventTracking.data.viewStartTime,
      leave_time: new Date().getTime(),
      scroll_height: eventTracking.data.scrollHeight,
      platform: eventTracking.data.platform,
      is_click_buy_now: eventTracking.data.isClickBuyNow,
      bid: bid,
      sid: sid,
      idx: idx,
      recordUrls: recordUrls,
      id: eventTracking.data.id,
    };
    //离开页面发送
    logSet({
      url: "/api/Log/log",
      data: setData,
    });
  }
}

function logSet(obj) {
  if (navigator.sendBeacon) {
    //新建formData数据
    let formData = new FormData();
    //数据转换
    Object.keys(obj.data).forEach(function (key) {
      let value = obj.data[key];
      if (typeof value !== "string") {
        // formData只能append string 或 Blob
        value = JSON.stringify(value);
      }
      formData.append(key, value);
    });
    navigator.sendBeacon(logHost + obj.url, formData);
  } else {
    ajaxRequest({
      url: obj.url,
      data: obj.data,
    });
  }
}

function uuid() {
  return (
    eventTrackingFormat(new Date(), "yyyyMMddhhmmss") +
    eventTrackingGetRandomString(6)
  );
}

function eventTrackingFormat(date, fmt) {
  let o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  //(y+)匹配多个y，比如yyyy
  if (/(y+)/.test(fmt)) {
    // RegExp.$1是RegExp的一个属性,指的是与正则表达式匹配的第一个 子匹配(以括号为标志)字符串
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
}

//生成随机字符串
function eventTrackingGetRandomString(len) {
  let _charStr =
      "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789",
    min = 0,
    max = _charStr.length - 1,
    _str = ""; //定义随机字符串 变量
  //判断是否指定长度，否则默认长度为15
  len = len || 15;
  //循环生成字符串
  for (let i = 0, index; i < len; i++) {
    index = (function (randomIndexFunc, i) {
      return randomIndexFunc(min, max, i, randomIndexFunc);
    })(function (min, max, i, _self) {
      let indexTemp = Math.floor(Math.random() * (max - min + 1) + min),
        numStart = _charStr.length - 10;
      if (i == 0 && indexTemp >= numStart) {
        indexTemp = _self(min, max, i, _self);
      }
      return indexTemp;
    }, i);
    _str += _charStr[index];
  }
  return _str;
}

async function ajaxRequest(obj) {
  obj.type && obj.type.toUpperCase();
  //fetch 页面即使退出也会发送这条数据 keepalive=true
  try {
    return await fetch(logHost + obj.url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj.data),
      keepalive: true,
    }).then(function (response) {
      if (obj.back) {
        return response.json();
      }
    });
  } catch (e) {
    console.log("ajaxRequest>>>", e);
    return new Promise((resolve, reject) => {
      obj.type && obj.type.toUpperCase();
      new Image().src = logHost + obj.url + "?" + objSerialize(obj.data);
    });
  }
}

// 设置会话 Cookie（只在当前会话有效）
function setSessionCookie(name, value) {
  document.cookie = name + "=" + encodeURIComponent(value) + ";path=/";
}

// 获取 Cookie
function getCookie(name) {
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookiesArray = decodedCookie.split(";");
  const cookieName = name + "=";

  for (let cookie of cookiesArray) {
    cookie = cookie.trim();
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return null; // 如果未找到对应的 Cookie
}

// 设置SessionStorage
function setSessionStorage(name, value) {
  let sessionStorage = window.sessionStorage;
  if (typeof sessionStorage !== "undefined") {
    // sessionStorage 可用
    sessionStorage.setItem(name, encodeURIComponent(value));
  } else {
    // 不支持 sessionStorage
    setSessionCookie(name, value);
    console.log("This browser does not support sessionStorage");
  }
}

// 获取SessionStorage
function getSessionStorage(name) {
  let data = "";
  let sessionStorage = window.sessionStorage;
  if (typeof sessionStorage !== "undefined") {
    // sessionStorage 可用
    data = sessionStorage.getItem(name);
    data = decodeURIComponent(data);
  } else {
    // 不支持 sessionStorage
    data = getCookie(name);
    console.error("This browser does not support sessionStorage");
  }
  return data;
}

//对象序列化
function objSerialize(obj) {
  let str = [];
  for (let p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

function setBidAndSidToUrl() {
  document.querySelectorAll("a").forEach((link) => {
    let href = link.href;
    if (href.startsWith("http") && href) {
      // 添加参数
      let url = new URL(href);
      if (url.hostname !== "puainta.com") {
        let sid = getCookie("customSessionId");
        let bid = localStorage.getItem("customId");
        let idx = getCookie("visitCount");
        let recordUrls = getRecordUrls();

        url.searchParams.set("bid", bid);
        url.searchParams.set("sid", sid);
        url.searchParams.set("idx", idx);
        url.searchParams.set("recordUrls", recordUrls);

        url.searchParams.set("utm_source", "puainta");
        url.searchParams.set("utm_medium", "web");
        url.searchParams.set("utm_content", link.textContent);
        link.setAttribute("href", url.toString());
      }
    }
  });
}
